var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icons } from 'src/ui/components/Icons/Icons';
import { COLORS } from 'src/shared/styles/colors';
import styles from './errorPlaceholder.module.scss';
import { E_ICONS } from 'src/ui/components/Icons/constants';
export var ErrorPlaceholder = function (props) {
    var title = props.title, text = props.text;
    return (_jsxs("div", __assign({ className: styles.errorPlaceholderWrapper }, { children: [_jsx(Icons, { icon: E_ICONS.WARNING, color: COLORS.RED['500'], className: styles.logo }), _jsx("p", __assign({ className: styles.title }, { children: title })), _jsx("p", __assign({ className: styles.text }, { children: text }))] })));
};
